<div class="tw:relative tw:mb-2 {{ extraClass }}" [class.tw:opacity-50]="isDisabled">
    <label
        class="tw:!flex tw:!cursor-pointer tw:!items-center tw:!mb-0"
        [class.tw:justify-center]="labelHidden"
    >
        <input
            class="tw:peer tw:hidden"
            type="checkbox"
            [checked]="value"
            (change)="handleInput($event)"
            [disabled]="isDisabled"
            [attr.aria-label]="labelHidden ? (ariaLabel || label) : null"
        />
        <div
            class="tw:flex tw:cursor-pointer tw:items-center tw:justify-center tw:rounded tw:bg-primary-500 tw:transition-colors"
            [ngClass]="{ 'tw:border-1 tw:border-neutral-500 tw:bg-white': !value, 'tw:!h-7 tw:!w-7': size === 'lg', 'tw:!h-5 tw:!w-5': size === 'sm', 'tw:!border-error-500': isInvalid }">
            <app-icon icon="check" class="tw:text-white" />
        </div>
        @if (!labelHidden) {
            <div class="tw:ml-4 tw:text-primary-300">
                <span [ngClass]="{ 'tw:text-base tw:font-semibold': size === 'lg', 'tw:text-xs': size == 'sm' }">{{ label }}</span>
                <ng-content />
            </div>
        }
    </label>
    @if (description) {
        <span class="tw:ml-9 tw:mt-2 tw:text-neutral-500" [ngClass]="{ 'tw:text-base tw:font-semibold': size === 'lg', 'tw:text-xs': size == 'sm' }">{{
            description
        }}</span>
    }
    @if (isInvalid) {
        <div class="tw:ml-9 tw:mt-2 tw:text-error-500">
                {{ errorMessage }}
        </div>
    }
</div>
